(function () {

    "use strict";

    angular
        .module('harriApp')
        .service('indeedCampaignsService', IndeedCampaignsService);

    IndeedCampaignsService.$inject = ['$q', 'harri.social.auth.providers', '$state', 'hModalService', '$filter'];

    function IndeedCampaignsService($q, socialProviders, $state, hModalService, $filter) {
        var self = this;

        self.login = function () {
            var defer = $q.defer();

            socialProviders.auth('indeed').then(function (response) {
                var code = response.code;
                var employer = response.employer;
                var redirectUrl = $state.href('oauth2_activation_request', {code: null}, {absolute: true});

                if (!code || !employer || !redirectUrl) {
                    console.error('Auth code did not returned, something wrong happened!');
                    return;
                }

                IndeedCampaignsAPI.login(code, employer, redirectUrl).then(function (response) {
                    defer.resolve(response);
                }, function (error) {
                    defer.reject(error);
                });
            }, function (error) {
                defer.reject(error);
            });

            return defer.promise;
        };

        self.checkLogin = function () {
            var defer = $q.defer();

            IndeedCampaignsAPI.checkLogin().then(function (response) {
                defer.resolve(response);
            }, function (error) {
                defer.reject(error);
            });

            return defer.promise;
        };

        self.logout = function () {
            var defer = $q.defer();

            IndeedCampaignsAPI.logout().then(function (response) {
                defer.resolve(response);
            }, function (error) {
                defer.reject(error);
            });

            return defer.promise;
        };

        self.getCampaigns = function (status, perPage, start, includeCreatedDate) {
            var defer = $q.defer();

            IndeedCampaignsAPI.getCampaigns(status, perPage, start, includeCreatedDate).then(function (response) {
                defer.resolve(response);
            }, function (error) {
                defer.reject(error);
            });

            return defer.promise;
        };

        self.orderCampaigns = function (campaigns, nextId) {
            let orderdCampaigns = campaigns.sort((campaign1, campaign2) => {
                let campaign1Date = campaign1 ? new Date(campaign1.dateCreated).getTime() : 0;
                let campaign2Date = campaign2 ? new Date(campaign2.dateCreated).getTime() : 0;
                return campaign1Date > campaign2Date ? -1 : 1;
            });
            return {orderdCampaigns: orderdCampaigns, 'nextId': nextId};
        };

        self.getOrderedCampaigns = function (status, includeCreatedDate, perPage, start) {
            var defer = $q.defer();

            self.getCampaigns(status, perPage, start, includeCreatedDate)
                .then(function (response) {
                    let orderdCampaigns = self.orderCampaigns(response.campaigns, response.next_id);
                    defer.resolve(orderdCampaigns);
                }).catch(function (error) {
                defer.reject(error);
            }).finally(function (error) {
                defer.reject(error);
            });

            return defer.promise;
        };
        self.getCampaign = function (id) {
            var defer = $q.defer();

            IndeedCampaignsAPI.getCampaign(id).then(function (response) {
                defer.resolve(response);
            }, function (error) {
                defer.reject(error);
            });

            return defer.promise;
        };

        self.getJobSources = function () {
            var defer = $q.defer();

            IndeedCampaignsAPI.getJobSources().then(function (response) {
                defer.resolve(response);
            }, function (error) {
                defer.reject(error);
            });

            return defer.promise;
        };

        self.getJobsList = function (boardCode, excludeCampaignId) {
            var defer = $q.defer();
            IndeedCampaignsAPI.getJobsList(boardCode, excludeCampaignId)
                .then(function (response) {
                    defer.resolve(response);
                }, function (error) {
                    defer.reject(error);
                });

            return defer.promise;
        };

        self.createCampaign = function (data) {
            var defer = $q.defer();

            IndeedCampaignsAPI.createCampaign(data).then(function (response) {
                defer.resolve(response);
            }, function (error) {
                defer.reject(error);
            });

            return defer.promise;
        };

        self.updateCampaign = function (campaignId, jobs) {
            var defer = $q.defer();

            IndeedCampaignsAPI.updateCampaign(campaignId, jobs).then(function (response) {
                defer.resolve(response);
            }, function (error) {
                defer.reject(error);
            });

            return defer.promise;
        };

        self.getAssignees = function () {
            var defer = $q.defer();

            BrandAPI.getBrandsAssignedJobsAdmins().then(function (response) {
                defer.resolve(response);
            }, function (error) {
                defer.reject(error);
            });

            return defer.promise;
        };

        self.openAddJobsToCampaignModal = function (campaignId, source) {
            hModalService.openModal({
                component: 'add-jobs-to-campaign-modal',
                title: 'Add Jobs',
                cssClass: 'add-jobs-to-campaign-modal',
                sizing: 'lg',
            }, {
                backdrop: 'static',
                resolve: {
                    modalData: function () {
                        return {
                            campaignId: campaignId,
                            source: source
                        };
                    },
                }
            });
        };

        self.handleError = function (e, redirect) {
            redirect = typeof redirect === 'undefined';

            var status = e && e.data && e.data.status;
            var message = $filter("translate")("Something went wrong, please try again later");

            switch (status) {
                case 'INDEED_INSUFFICIENT_SCOPE':
                    message = $filter("translate")("Connection error with Indeed account: not enough permissions");
                    self.logout();

                    if (redirect) {
                        $state.go('appLayout.harriSH.access-portal.indeed-campaigns');
                    }

                    break;
                case 'INDEED_AUTHENTICATION_FAILED':
                    message = $filter("translate")("Authentication failed");
                    self.logout();

                    if (redirect) {
                        $state.go('appLayout.harriSH.access-portal.indeed-campaigns');
                    }

                    break;
                case 'DUPLICATE_CAMPAIGN_NAME':
                    message = $filter("translate")("The name of campaign is already used");

                    break;
            }

            HNotifications.show({
                title: $filter("translate")("Error"),
                desc: message,
                icon: "fa-times",
                type: "danger",
                timeout: 5000
            });
        };

        self.campaignStatuses = [
            {
                code: 'ACTIVE',
                label: 'Active Campaigns',
            },
            {
                code: 'PAUSED',
                label: 'Paused Campaigns'
            },
            {
                code: 'DELETED',
                label: 'Deleted Campaigns'
            },
        ];
    }
})();